<app-page-header [title]="getPageTitle()" icon="rate_review"></app-page-header>
<div [@fadeInOut] class="page-content">
  <form #form="ngForm" [formGroup]="standardForm" (ngSubmit)="save()" novalidate fxLayout="column" fxLayoutGap="1em" autocomplete="off">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Namn</mat-label>
            <input matInput formControlName="name" required />
            @if (getFormControl('name').hasError('required')) {
              <mat-error>Namn är obligatoriskt</mat-error>
            }
            @if (getFormControl('name').hasError('maxlength')) {
              <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
            }
          </mat-form-field>
          @if (noOfStandards >= 0) {
            <mat-form-field class="flex-1">
              <mat-label>Sortering</mat-label>
              <mat-select formControlName="sortOrder" required >
                @for (val of getSortOrderItems(); track val) {
                  <mat-option [value]="val">{{ val }}</mat-option>
                }
              </mat-select>
              @if (getFormControl('sortOrder').hasError('required')) {
                <mat-error>Sortering är obligatorisk</mat-error>
              }
            </mat-form-field>
          }
          <div class="flex-1">
            <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
          </div>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Beskrivning</mat-label>
            <textarea rows="4" matInput formControlName="description"></textarea>
          </mat-form-field>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Förslag</mat-label>
            <textarea rows="4" matInput formControlName="suggestions"></textarea>
          </mat-form-field>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Frågor/noteringar</mat-label>
            <textarea rows="4" matInput formControlName="internalNotes"></textarea>
          </mat-form-field>
        </div>
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Skapad av</mat-label>
              <input matInput value="{{ createdByName$ | async }}" [readonly]="true" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Skapad</mat-label>
              <input matInput formControlName="createdDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad av</mat-label>
              <input matInput value="{{ changedByName$ | async }}" [readonly]="true" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad</mat-label>
              <input matInput formControlName="updatedDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Standard Id</mat-label>
              <input matInput formControlName="standardId" [readonly]="true" />
            </mat-form-field>
          </div>
        }
      </mat-card-content>
      <mat-card-actions>
        <section class="button-container">
          @if (hasPermissionToChange()) {
            <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
          }
          <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
        </section>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
